import { MutableRefObject, Ref } from 'react';

/**
 * Merges multiple Refs into a single Ref.
 *
 * @param refs Refs to merge.
 */
export function mergeRefs<T>(...refs: (Ref<T> | undefined)[]): (value: T) => void {
    return (value: T) => {
        refs.forEach((ref) => updateRef(ref, value));
    };
}

/**
 * Updates ref value.
 *
 * @param ref Ref to update.
 * @param value Value of ref.
 */
export function updateRef<T>(ref: Ref<T> | undefined, value: T): void {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref) {
        (ref as MutableRefObject<T>).current = value;
    }
}
